import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiPlus, FiMinus } from "react-icons/fi";

import { IoIosArrowRoundForward, IoIosArrowRoundBack } from "react-icons/io";
import Breadcrumb from "../components/BreadCrumb";

const Services = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  const location = useLocation();
  const { bgImage, description, title, features, _vId } = location.state || {};
  const [expandedFeature, setExpandedFeature] = useState(null);

  const toggleFeature = (idx) => {
    setExpandedFeature(expandedFeature === idx ? null : idx);
  };

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const iframeSrc = `https://www.youtube.com/embed/${_vId}`;
  const videoId = iframeSrc.split("/embed/")[1].split("?")[0];
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  const handleVideoClick = (video) => {
    setIsOpen(true);
    setSelectedVideo(video);
  };
  const paths = [
    { label: t("homepage"), link: "/" },
    { label: t("services").toUpperCase(), link: "/" },
  ];
  return (
    <div className="w-full min-h-screen bg-white">
      <div className="pt-32">
        <Breadcrumb paths={paths} />
      </div>
      <div className="container mx-auto pt-16 px-3 lg:px-10 2xl:px-px">
        <div className="w-full lg:h-[500px] lg:rounded-lg bg-black relative">
          <img
            src={bgImage}
            className="w-full h-full object-cover lg:rounded-lg opacity-50 "
          />
          <h1 className="text-3xl lg:text-6xl text-primary absolute inset-0 z-10 text-center flex items-center justify-center">
            {title}
          </h1>
        </div>
        <div className="flex flex-col items-start gap-6 py-12">
          <p className="text-xl lg:w-3/4 text-neutral-500 leading-relaxed">
            {t(description)}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 py-10">
          <div className="col-span-1 flex flex-col gap-5">
            {features.slice(0, 3).map((feature, idx) => (
              <div key={idx} className="flex flex-col">
                <div
                  className="flex items-center justify-between cursor-pointer w-full border-b-2 border-neutral-300 pb-4 mb-6"
                  onClick={() => toggleFeature(idx)}
                >
                  <h1 className="text-2xl font-semibold">{t(feature.title)}</h1>
                  <div
                    className={`p-2 rounded-full transition-all duration-300 ${
                      expandedFeature === idx ? "bg-primary " : "bg-gray-200 "
                    }`}
                  >
                    {expandedFeature === idx ? (
                      <FiMinus className="text-xl" />
                    ) : (
                      <FiPlus className="text-xl" />
                    )}
                  </div>
                </div>
                <AnimatePresence>
                  {expandedFeature === idx && (
                    <div className="flex flex-col items-start gap-2">
                      <motion.p
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-neutral-500 mt-2 "
                      >
                        {t(feature.description)}
                      </motion.p>
                      {/* <motion.button
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.5 }}
                        onClick={() => navigate("/Portfolio")}
                        className="flex items-center gap-2  bg-primary px-4 py-2  rounded-md"
                      >
                        {t("read_more")}
                        <span>

                          {i18n.language === "en" ? (
                            <IoIosArrowRoundForward className="w-6 h-6 pt-px" />
                          ) : (
                            <IoIosArrowRoundBack className="w-6 h-6 pt-px" />
                          )}

                        </span>
                      </motion.button> */}
                    </div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
          <div className="col-span-1 flex flex-col gap-5">
            {features.slice(3).map((feature, idx) => (
              <div key={idx + 3} className="flex flex-col">
                <div
                  className="flex items-center justify-between cursor-pointer w-full border-b-2 border-neutral-300 pb-4 mb-6"
                  onClick={() => toggleFeature(idx + 3)}
                >
                  <h1 className="text-2xl font-semibold">{t(feature.title)}</h1>
                  <div
                    className={`p-2 rounded-full transition-all duration-300 ${
                      expandedFeature === idx + 3
                        ? "bg-primary "
                        : "bg-gray-200 "
                    }`}
                  >
                    {expandedFeature === idx + 3 ? (
                      <FiMinus className="text-xl" />
                    ) : (
                      <FiPlus className="text-xl" />
                    )}
                  </div>
                </div>
                <AnimatePresence>
                  {expandedFeature === idx + 3 && (
                    <div className="flex flex-col items-start gap-2">
                      <motion.p
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-neutral-500 mt-2 "
                      >
                        {t(feature.description)}
                      </motion.p>
                      {/* <motion.button
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.5 }}
                        onClick={() => navigate("/Portfolio")}
                        className="flex items-center gap-2 bg-primary p-1 rounded-md"
                      >

                        {t("read_more")}.,mbb,mb,mnb,nbbn

                        <span>
                          {i18n.language === "en" ? (
                            <IoIosArrowRoundForward className="w-6 h-6 pt-px" />
                          ) : (
                            <IoIosArrowRoundBack className="w-6 h-6 pt-px" />
                          )}
                        </span>
                      </motion.button> */}
                    </div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
